import { ValueVector } from "@core/components/value-vector";
import { formatAsCrore, formatAsPercentage } from "creso-core/utils";
import { ProductBreakdownItem } from "creso-core/types";

export function ProductsReport({
  products,
}: {
  products: ProductBreakdownItem[];
}) {
  if (products.length < 2) return null;

  return (
    <div className="flex flex-col gap-4">
      <h4>Products</h4>
      <div className="flex flex-row gap-4">
        {products.map((product) => (
          <div
            key={product.key}
            className="flex flex-1 flex-col gap-2 rounded-lg bg-muted p-4 text-sm"
          >
            <div className="flex flex-row items-center justify-between">
              <span className="font-semibold">{product.label}</span>
              <span className="font-semibold">
                {formatAsCrore(product.currentValue ?? "")}
              </span>
            </div>
            <div className="flex flex-row items-center justify-between">
              <span className="text-muted-foreground">
                {product.allocationPct != null
                  ? `${formatAsPercentage(product.allocationPct, "-", 0)} allocation`
                  : product.subText}
              </span>
              {product.growthPct != null ? (
                <ValueVector value={product.growthPct} />
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
